import Swiper from 'swiper';
import { Keyboard, A11y, FreeMode, Mousewheel } from 'swiper/modules';
import WebFont from "webfontloader";

class Anchors {
  constructor() {
    const anchorsSliders = window.wrapper.querySelectorAll('.block--anchors .swiper');
    const preloadFonts = () => new Promise((resolve) => {
      WebFont.load({
        custom: {
          families: ['TT Commons'],
        },
        active: resolve
      });
    });

    Promise.all([preloadFonts()]).then(() => {
      [].forEach.call(anchorsSliders, (slider) => {
        Anchors.initSlider(slider)
      });
    });
  }

  static swiperResizeCallBack(swiper) {
    swiper.slideTo(1, 0, false);
    for (let index = 0; index < swiper.$wrapperEl.length; index++) {
      const wrapper = swiper.$wrapperEl[index];
      wrapper.style.transform = '';
    }
  }

  static swiperUpdateCallback(swiper){
    const swiperEl = swiper.el;
    const sliderWidth = swiperEl.getBoundingClientRect().width;
    let slidesDims = 0;

    swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
      slidesDims += slide.getBoundingClientRect().width + 70;
    });
    swiperEl.classList.toggle('swiper-no-swiping', sliderWidth > slidesDims);
    swiperEl.style.cursor = sliderWidth > slidesDims ? '' : 'grab';
  }

  /**
   * Init slider
   *
   * @param  {HTMLElement} slider
   */
  static initSlider(slider) {
    const slides = slider.getElementsByClassName('swiper-slide');

    if(slides.length < 1){
      return;
    }

    return new Swiper(slider, {
      modules: [FreeMode, A11y, Keyboard, Mousewheel],
      slidesPerView: 'auto',
      freeMode: true,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true
      },
      on: {
        resize: (swiper) => {
          this.swiperResizeCallBack(swiper);
          this.swiperUpdateCallback(swiper);
        },
        init: this.swiperUpdateCallback,
      }
    });
  }
}

export default Anchors;
